var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null)

var cookie = require('js-cookie')
var DONATE_BUTTON_COOKIE = 'STYXKEY_donate_button_closed'
var HIDE_CLASS = 'is-hidden'

module.exports = function (el) {
  var $el = $(el)
  var $closeBtn = $(el).find('.js-donate-button-close')
  if ($closeBtn) {
    $closeBtn.on('click', function () {
      $el.addClass(HIDE_CLASS)
      cookie.set(DONATE_BUTTON_COOKIE, 'true', { expires: 1 })
    })
  }
}
